"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _escape = _interopRequireDefault(require("lodash/escape"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = {
  escape: _escape.default
};

var _default = function _default(obj) {
  var __t,
      __p = '',
      __e = _.escape;

  __p += '\n<a href="data:' + __e(obj.contentType) + ';base64,' + __e(obj.content) + '" download="' + __e(obj.filename) + '">\n	Download\n</a>';
  return __p;
};

exports.default = _default;